import React, { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import "../Table/filter.scss";
import ComboBox from "../ComboBox";
import filter from "../../assets/images/filter.svg";
import dropdown from "../../assets/images/dropdown.svg";
import ComboBoxMultiSelect from "../ComboBoxMultiSelect";
import "./style.scss";
import {
  fetchCustomerDropdown,
  fetchBuildingDropdown,
  fetchFloorDropdown,
  fetchDeviceTypeDropdown,
} from "../../Actions/DeviceComponent";

export default function FloorFilter(props) {
  const dispatch = useDispatch();
  const { filters, page, setFilters, setPage } = props;

  const {
    customerDropdownSuccess,
    buildingDropdownSuccess,
    floorDropdownSuccess,
    deviceTypeDropdownSuccess,
  } = useSelector((state) => state.deviceComponent);
  const customerComboRef = useRef(null);
  const [customer, setCustomer] = useState([]);
  const [buildingId, setBuildingId] = useState("");
  const [floorName, setFloorName] = useState("");
  const [statusMessage, setStatusMessage] = useState("");
  const [showFilters, setShowFilters] = useState(false);

  const SORT_FIELD_MAP = {
  deviceType: "type",
  dateInstalled: "installed",
  buildingId: "buildingId",
  deviceName: "deviceName",
};

  useEffect(() => {
    if (filters) {
      setCustomer(filters.customerNames || []);
      setBuildingId(filters.buildingId?.[0] || "");
      setFloorName(filters.floorName?.[0] || "");
    }
  }, [filters, deviceTypeDropdownSuccess]);

  useEffect(() => {
    dispatch(fetchCustomerDropdown());
    dispatch(fetchDeviceTypeDropdown());
  }, [dispatch]);

  useEffect(() => {
    if (customer?.length > 0) {
      const selectedCustIds = customerDropdownSuccess
        ?.filter((cust) => customer.includes(cust.id))
        ?.map((cust) => cust.id);

      dispatch(fetchBuildingDropdown(selectedCustIds));
    }
  }, [customer, dispatch, customerDropdownSuccess]);

  useEffect(() => {
    if (buildingId) {
      dispatch(fetchFloorDropdown([buildingId]));
      setFloorName("");
    }
  }, [buildingId, dispatch]);

  const isAnyAppliedFilter =
    (filters?.customerNames?.length ?? 0) > 0 ||
    (filters?.buildingId?.length ?? 0) > 0 ||
    (filters?.floorName?.length ?? 0) > 0;

  const isAnyLocalInput =
    customer.length > 0 ||
    !!buildingId ||
    !!floorName;

  const handleApply = () => {
    const appliedFilters = [];

    if (customer.length > 0)
      appliedFilters.push(`Customer: ${customer.join(", ")}`);

    if (buildingId) appliedFilters.push(`Building: ${buildingId}`);

    if (floorName) appliedFilters.push(`Floor: ${floorName}`);
    setFilters({
      customerNames: customer,
      buildingId: buildingId ? [buildingId] : [],
      floorName: floorName ? [floorName] : [],
      page: page - 1,
      size: 5,
      ...(filters?.sort && {
      sortBy: SORT_FIELD_MAP[filters.sort.field] || filters.sort.field,
      sortDirection: filters.sort.order,
    }),
    });

    setPage(1);

    setStatusMessage(
      appliedFilters.length > 0
        ? `Filters applied. ${appliedFilters.join(", ")}.`
        : "No filters applied."
    );
  };

  const handleClear = () => {
    setCustomer([]);
    setBuildingId("");
    setFloorName("");
    setFilters({
      customerNames: [],
      buildingId: [],
      floorName: [],
    });

    setStatusMessage("All filters cleared.");
    setPage(1);

    setTimeout(() => {
      customerComboRef?.current?.focus();
    }, 0);
  };

  return (
    <div className="global-filters deviceFilters">
      <div
        className="filtertn-forMobile"
        onClick={() => setShowFilters((prev) => !prev)}
        aria-expanded={showFilters}
        aria-controls="filterOptions"
      >
        <span>
          <img src={filter} alt="" /> Filter
        </span>
        <span>
          <img
            src={dropdown}
            alt=""
            className={`drpIcon ${showFilters ? "toggleIcon" : ""}`}
          />
        </span>
      </div>

      <div className={`filterOptions ${showFilters ? "active" : "hidden"}`}>
        <ComboBoxMultiSelect
          label="Select Customer"
          ariaLabel="Filter Customer Column"
          options={
            customerDropdownSuccess
              ?.map((c) => ({ key: c.id, value: c.name }))
              ?.sort((a, b) => a.value.localeCompare(b.value)) ?? []
          }
          value={customer}
          handleChange={(value) => setCustomer(value)}
          handleFocusRef={(ref) => (customerComboRef.current = ref)}
        />

        <ComboBox
          label="Select Building Id"
          ariaLabel="Filter Building Id Column"
          options={buildingDropdownSuccess?.map((b) => b.id) ?? []}
          value={buildingId}
          onChange={setBuildingId}
          disabled={!customer?.length}
        />

        <ComboBox
          label="Select Floor"
          ariaLabel="Filter Floor Column"
          options={floorDropdownSuccess?.map((f) => f.name) ?? []}
          value={floorName}
          onChange={setFloorName}
          disabled={!buildingId}
        />

        <div className="clearbtns">
          <button
            className={`filter-btn applyfilterbtn ${
              isAnyLocalInput ? "activeFilterBtn" : "inactiveFilterBtn"
            }`}
            disabled={!isAnyLocalInput}
            onClick={handleApply}
          >
            Apply Filter
          </button>

          {(isAnyAppliedFilter || isAnyLocalInput) && (
            <button
              className={`filter-btn clearfilterbtn ${
                isAnyAppliedFilter || isAnyLocalInput
                  ? "activeclearrBtn"
                  : "inactiveclearrBtn"
              }`}
              disabled={!(isAnyAppliedFilter || isAnyLocalInput)}
              onClick={handleClear}
            >
              Clear
            </button>
          )}
        </div>
      </div>

      <div
        className="sr-only"
        role="status"
        aria-live="polite"
        aria-atomic="true"
      >
        {statusMessage}
      </div>
    </div>
  );
}
